import Head from 'next/head';

import MyOrders from '../../components/MyOrders';
import { pageTitle } from '../../components/shared/basic/customHead';

const MyOrdersPage = () => {
  return (
    <div>
      <Head>
        <title>{pageTitle('My Orders')}</title>
      </Head>
      <MyOrders />
    </div>
  );
};

export default MyOrdersPage;
